import { ForwardedRef } from 'react';
import { FieldError, RefCallBack } from 'react-hook-form';
import classes from './styles.module.scss';

export default function Input({
	min,
	label,
	onChange,
	onBlur,
	type = 'text',
	size = 'md',
	placeholder = '',
	onFocus,
	error,
	name,
	withLabel = true,
	defaultValue = null,
	innerRef,
	disabled = false,
}: {
	min?: number | string;
	name: string;
	label?: React.ReactNode;
	onChange?: (...event: any[]) => (void | Promise<void>) | React.ChangeEventHandler<HTMLInputElement>;
	onBlur?: (...event: any[]) => void | Promise<void>;
	type?: string;
	size?: 'md' | 'sm' | 'lg';
	placeholder?: string;
	onFocus?: (...event: any[]) => void | Promise<void>;
	error?: FieldError;
	withLabel?: boolean;
	defaultValue?: any;
	innerRef?: RefCallBack;
	disabled?: boolean;
}) {
	return (
		<label htmlFor="input" className={withLabel ? classes.label : ''}>
			{label && <span className={classes.label__title}>{label}</span>}
			<input
				ref={innerRef}
				id="input"
				autoComplete="off"
				onChange={onChange}
				onBlur={onBlur}
				type={type}
				name={name}
				className={[classes.input, error && classes.error, classes[`input--${size}`]].filter(Boolean).join(' ')}
				min={min}
				placeholder={placeholder}
				// TODO onFocus нужен для InputMask
				onFocus={onFocus}
				defaultValue={defaultValue}
				disabled={disabled ? true : false}
			/>
			{error && <small className={classes.label__error}>{error.message}</small>}
		</label>
	);
}
